// extracted by mini-css-extract-plugin
export default {"aside":"Sidebar_aside__RWTBc"};